import React from "react";
import { useLang } from "../i18n";

export default function Cases() {
  const { t } = useLang();
  return (
    <section id="cases" data-testid="cases-section" className="py-24 md:py-36 border-t border-gt-cream/8 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="section-eyebrow mb-6">
              <span className="gt-eyebrow">{t.cases.eyebrow}</span>
            </div>
            <h2 className="gt-display text-gt-cream text-4xl md:text-6xl lg:text-7xl">
              {t.cases.title_a} <span className="block text-gt-cream/55 gt-display-light">{t.cases.title_em}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-base md:text-lg text-gt-ink/75 leading-relaxed">{t.cases.subtitle}</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gt-cream/8">
          {t.cases.items.map((c, i) => (
            <div
              key={i}
              data-testid={`case-card-${i + 1}`}
              className="bg-gt-bg p-8 md:p-10 min-h-[280px] flex flex-col justify-between hover:bg-gt-surface2/40 transition-colors"
            >
              <div className="text-[0.65rem] uppercase tracking-[0.26em] text-gt-cream/70">{c.label}</div>
              <div className="my-6">
                <div className="gt-bignumber text-6xl md:text-7xl lg:text-[5.5rem]">{c.metric}</div>
              </div>
              <p className="text-sm text-gt-ink/65 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
